import axios from "axios";

const REACT_APP_API_ENDPOINT = `https://openaichat-api.websperotech.com/api`;
//  'http://localhost:4000/api'
// const REACT_APP_API_ENDPOINT = process.env.RREACT_APP_API_ENDPOINT;

// Headers
const getHeaders = () => {
  return {
    "Content-Type": "application/json",
  };
};

// Final method
const API_REQUEST = async (method, url, data) => {

  const headers = getHeaders();

  try {
    const response = await axios({
      headers,
      method,
      url: `${REACT_APP_API_ENDPOINT}/${url}`,
      data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export default API_REQUEST;
